export default __webpack_public_path__ + "static/media/Gellix-ExtraBold.441e5f0b.woff2";